import React from "react";
import LegalCmsPage, { PRIVACY_PAGE_ID } from "./LegalCmsPage";

const PrivacyPolicy: React.FC = () => {
  return <LegalCmsPage pageId={PRIVACY_PAGE_ID} failedKey="privacy_load_failed" />;
};

export default PrivacyPolicy;
